import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ToastSeverity } from '@/types';

interface ToastState {
  message: string;
  open: boolean;
  severity: ToastSeverity;
}

const initialState: ToastState = {
  message: '',
  open: false,
  severity: 'success',
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    setToast(state, action: PayloadAction<{ message: string; severity?: ToastSeverity }>) {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity ?? 'success';
    },
    resetToast(state) {
      state.open = false;
      state.message = '';
    },
  },
});

export const { setToast, resetToast } = toastSlice.actions;
export default toastSlice.reducer;
